(function () {
  function initEventsViewMore() {
    var buttons = document.querySelectorAll('[data-events-view-more]');
    if (!buttons.length) return;

    buttons.forEach(function (button) {
      button.addEventListener('click', function () {
        var group = button.closest('[data-events-group]');
        if (!group) return;

        var hiddenItems = group.querySelectorAll('.events__item--hidden');
        hiddenItems.forEach(function (item) {
          item.classList.remove('events__item--hidden');
        });

        button.setAttribute('aria-expanded', 'true');
        button.parentElement.style.display = 'none';
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initEventsViewMore);
  } else {
    initEventsViewMore();
  }
})();
